type RecapElementProps = {
    value: string;
    id: string;
    label?: string;
}

export default function RecapElement({value, id, label, ...props}: RecapElementProps) {
    return (
        <>
        <p className="text fz-sm">{label}</p>
        <p className="text fw-bold fz-normal" id={id}>
            {value}
        </p>
        </>
    );
} 